import { useState } from "react";

import Homebutton from "../Homebutton";
import FotoCard from "../components/FotoCard";

import { KABELS } from "../data/kabels";

function Invoerkabels() {
    const [kabels, setKabels] = useState(KABELS);

  return (
    <div className='container'>
      <div className='container-box'>
        <h1 className='text-center'>Invoerkabels</h1>
        <h2 className='text-center'>Welke invoerkabels zijn er?</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium ea autem aspernatur porro aperiam consequuntur similique repellat veritatis a qui nihil maxime aliquid adipisci repellendus eum, perspiciatis molestiae totam, omnis rem commodi rerum facere in?
        </p>
        
        {/* loop over verschillende items in kabels object en render een foto card per item */}
        {kabels.map((item) => {
          return (
            <FotoCard item={item} key={item.key} />
          )
        })}

              <Homebutton />
      </div>
    </div>
  );
}

export default Invoerkabels;
